import { Lead, Paragraph } from '@sbab-ui/components'
import { useEffect, useState } from 'react'

interface Props {
  yearlySavingsKWh: number
  userConsumption?: number
}

export default function ConsumptionGraphic({ yearlySavingsKWh, userConsumption }: Readonly<Props>) {
  const [animatedYearlyConsumptionToday, setAnimatedYearlyConsumptionToday] = useState(1)
  const [animatedYearlyConsumptionWithSuggestion, setAnimatedYearlyConsumptionWithSuggestion] =
    useState(1)
  const animateValue = (
    start: number,
    end: number,
    duration: number,
    onProgress: React.Dispatch<React.SetStateAction<number>>,
  ) => {
    let startTime: number | null = null
    const step = (currentTime: number) => {
      if (!startTime) startTime = currentTime
      const progress = Math.min((currentTime - startTime) / duration, 1)
      onProgress(Math.round(start + (end - start) * progress))
      if (progress < 1) {
        window.requestAnimationFrame(step)
      }
    }
    window.requestAnimationFrame(step)
  }

  useEffect(() => {
    animateValue(0, userConsumption || 0, 400, setAnimatedYearlyConsumptionToday)
    animateValue(
      0,
      (userConsumption || 0) - yearlySavingsKWh,
      400,
      setAnimatedYearlyConsumptionWithSuggestion,
    )
  }, [yearlySavingsKWh, userConsumption])

  const fullBarHeight = 167
  const calculateHeight = (value: number) => {
    return (value / (userConsumption || 0)) * fullBarHeight
  }

  return (
    <div className="flex flex-col gap-2">
      <Lead className="!mt-0">Uppskattad total förbrukning</Lead>
      <div className="flex flex-col gap-4">
        <div className="relative flex min-h-44 w-64 items-end gap-[10px]">
          <div
            style={{
              height: `${calculateHeight(animatedYearlyConsumptionToday)}px`,
              transition: 'height 1s ease',
            }}
            className="bottom-0 w-[120px] bg-orange"
            aria-label="Elkostnad idag grafik"
          />
          <div
            style={{
              height: `${calculateHeight(animatedYearlyConsumptionWithSuggestion)}px`,
              transition: 'height 1s ease',
            }}
            className="bottom-0 left-[128px] w-[120px] bg-black"
            aria-label="Elkostnad efter installation grafik"
          />
        </div>
        <div>
          <Paragraph className="!mb-2 !mt-0  before:mb-[-2px] before:mr-2 before:inline-block before:h-4 before:w-2 before:bg-orange before:content-['']">
            Idag ca {animatedYearlyConsumptionToday.toLocaleString('sv-SE')} kWh/år
          </Paragraph>
          <Paragraph className="!mt-0  before:mb-[-2px] before:mr-2 before:inline-block before:h-4 before:w-2 before:bg-black before:content-['']">
            Efter åtgärd {animatedYearlyConsumptionWithSuggestion.toLocaleString('sv-SE')} kWh/år
          </Paragraph>
        </div>
      </div>
    </div>
  )
}
